import React, { memo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { tasksState } from '../../taskRefactored/tasks.slice'
import TestRunMain from '../../testRun'
import TestRunDetails from '../../testRun/components/testRun/details/TestRunDetails'
import { PRIVATE_ROUTES } from '../../../routes'
import ProjectTaskList from '../ProjectTaskList'
import ProjectRoadMap from '../ProjectRoadMap'
import DevelopmentSprintView from './DevelopmentSprintView'
import FloatingViewTabs from './FloatingViewTabs'
import ProjectFiles from './ProjectFiles'
import ProjectPrototype from './ProjectPrototype'
import ProjectStoryMap from './ProjectStoryMap'
import ProjectTaskListView from './listView/ProjectTaskListView'
import ReportsView from './reports/ReportsView'
import styles from '../projectDetail.module.css'

const ProjectMainContent = ({
    activeMainTab,
    canViewSupportTab,
    supportSubView,
    developmentSubView,
    projectId,
    routeId,
    taskId,
    onTaskClick,
    taskDetailVisible,
    addTaskToFirstSwimlaneRef,
    liveTaskTitlePatch,
    applySupportToolbarQuery,
    supportListQuery,
    taskListSearchTerm,
    applyDevelopmentToolbarQuery,
    showTaskListRefreshOverlay = false,
    filteredAssignees,
    projectName,
    canViewTestRun,
    canAccessStoryMapRoute,
    storyMapReadOnly,
    storyMapCanDelete,
    canAccessPrototypeRoute,
    routeView,
    prototypeReadOnly,
    prototypeCanDelete,
    developmentViewTabs,
    supportViewTabs,
    onDevelopmentSubViewChange,
    onSupportSubViewChange,
}) => {
    const {
        projectTaskList,
        projectTaskListStatus,
        projectTaskListPage,
        projectTaskListIsNext,
        projectMainTaskList,
        projectMainTaskListStatus,
        projectMainTaskListPage,
        projectMainTaskListIsNext,
    } = useSelector(
        (state) => {
            const tasks = tasksState(state)
            return {
                projectTaskList: tasks.projectTaskList,
                projectTaskListStatus: tasks.projectTaskListStatus,
                projectTaskListPage: tasks.projectTaskListPage,
                projectTaskListIsNext: tasks.projectTaskListIsNext,
                projectMainTaskList: tasks.projectMainTaskList,
                projectMainTaskListStatus: tasks.projectMainTaskListStatus,
                projectMainTaskListPage: tasks.projectMainTaskListPage,
                projectMainTaskListIsNext: tasks.projectMainTaskListIsNext,
            }
        },
        shallowEqual
    )

    return (
        <div className={styles.projectMainBody}>
            {activeMainTab === 'support' &&
                canViewSupportTab &&
                supportSubView === 'board' && (
                    <ProjectTaskList
                        projectTaskList={projectTaskList}
                        projectTaskListStatus={projectTaskListStatus}
                        projectTaskListPage={projectTaskListPage}
                        projectTaskListIsNext={projectTaskListIsNext}
                        projectId={projectId}
                        onTaskClick={onTaskClick}
                        taskDetailVisible={taskDetailVisible}
                        onAddTaskToFirstSwimlane={addTaskToFirstSwimlaneRef}
                        taskRouteView={supportSubView}
                        liveTaskTitlePatch={liveTaskTitlePatch}
                        onRefreshTasks={applySupportToolbarQuery}
                        listQuery={supportListQuery}
                        showRefreshOverlay={showTaskListRefreshOverlay}
                    />
                )}

            {activeMainTab === 'support' &&
                canViewSupportTab &&
                supportSubView === 'list' && (
                    <ProjectTaskListView
                        projectTaskList={projectTaskList}
                        projectTaskListStatus={projectTaskListStatus}
                        projectTaskListPage={projectTaskListPage}
                        projectTaskListIsNext={projectTaskListIsNext}
                        projectId={projectId}
                        onTaskClick={onTaskClick}
                        taskDetailVisible={taskDetailVisible}
                        onAddTaskToFirstSwimlane={addTaskToFirstSwimlaneRef}
                        liveTaskTitlePatch={liveTaskTitlePatch}
                        searchTerm={taskListSearchTerm}
                        onRefreshTasks={applySupportToolbarQuery}
                        listQuery={supportListQuery}
                        showRefreshOverlay={showTaskListRefreshOverlay}
                    />
                )}

            {activeMainTab === 'support' &&
                canViewSupportTab &&
                supportSubView === 'roadmap' && (
                    <ProjectRoadMap
                        apiData={projectTaskList}
                        onTaskClick={onTaskClick}
                        projectId={projectId}
                        onRefreshTasks={applySupportToolbarQuery}
                    />
                )}

            {activeMainTab === 'development' &&
                developmentSubView === 'board' && (
                    <ProjectTaskList
                        taskListKind="main"
                        projectTaskList={projectMainTaskList}
                        projectTaskListStatus={projectMainTaskListStatus}
                        projectTaskListPage={projectMainTaskListPage}
                        projectTaskListIsNext={projectMainTaskListIsNext}
                        projectId={projectId}
                        onTaskClick={onTaskClick}
                        taskDetailVisible={taskDetailVisible}
                        onAddTaskToFirstSwimlane={addTaskToFirstSwimlaneRef}
                        taskRouteView={developmentSubView}
                        liveTaskTitlePatch={liveTaskTitlePatch}
                        onRefreshTasks={applyDevelopmentToolbarQuery}
                        showRefreshOverlay={showTaskListRefreshOverlay}
                    />
                )}

            {activeMainTab === 'development' &&
                developmentSubView === 'list' && (
                    <ProjectTaskListView
                        taskListKind="main"
                        projectTaskList={projectMainTaskList}
                        projectTaskListStatus={projectMainTaskListStatus}
                        projectId={projectId}
                        onTaskClick={onTaskClick}
                        taskDetailVisible={taskDetailVisible}
                        onAddTaskToFirstSwimlane={addTaskToFirstSwimlaneRef}
                        liveTaskTitlePatch={liveTaskTitlePatch}
                        searchTerm={taskListSearchTerm}
                        onRefreshTasks={applyDevelopmentToolbarQuery}
                        showRefreshOverlay={showTaskListRefreshOverlay}
                    />
                )}

            {activeMainTab === 'development' &&
                developmentSubView === 'roadmap' && (
                    <ProjectRoadMap
                        apiData={projectMainTaskList}
                        onTaskClick={onTaskClick}
                        projectId={projectId}
                        taskListKind="main"
                        onRefreshTasks={applyDevelopmentToolbarQuery}
                    />
                )}

            {activeMainTab === 'development' &&
                developmentSubView === 'sprint' && (
                    <div className={styles.developmentSprintHost}>
                        <DevelopmentSprintView
                            onTaskClick={onTaskClick}
                            projectId={projectId}
                            filteredAssignees={filteredAssignees}
                            onRefresh={applyDevelopmentToolbarQuery}
                            showRefreshOverlay={showTaskListRefreshOverlay}
                        />
                    </div>
                )}

            {activeMainTab === 'reports' && (
                <ReportsView projectId={projectId} projectName={projectName} />
            )}

            {activeMainTab === 'testrun' && canViewTestRun && !taskId && (
                <div className={styles.fullTabScrollHost}>
                    <TestRunMain projectId={projectId} />
                </div>
            )}

            {activeMainTab === 'testrun' && canViewTestRun && taskId && (
                <div className={styles.fullTabScrollHost}>
                    <TestRunDetails
                        reportId={taskId}
                        projectId={projectId}
                        backPath={PRIVATE_ROUTES.projects.projectIdView(
                            routeId,
                            'testrun'
                        )}
                    />
                </div>
            )}

            {activeMainTab === 'files' && (
                <div className={styles.filesTabHost}>
                    <ProjectFiles
                        projectId={projectId}
                        onTaskClick={onTaskClick}
                    />
                </div>
            )}

            {activeMainTab === 'storyMap' && canAccessStoryMapRoute && (
                <div className={styles.storyMapTabHost}>
                    <ProjectStoryMap
                        projectId={projectId}
                        readOnly={storyMapReadOnly}
                        canDelete={storyMapCanDelete}
                    />
                </div>
            )}

            {activeMainTab === 'prototype' && canAccessPrototypeRoute && (
                <div className={styles.storyMapTabHost}>
                    <ProjectPrototype
                        projectId={projectId}
                        prototypeId={
                            routeView === 'prototype' ? taskId || null : null
                        }
                        readOnly={prototypeReadOnly}
                        canDelete={prototypeCanDelete}
                    />
                </div>
            )}

            {activeMainTab === 'development' && (
                <FloatingViewTabs
                    tabs={developmentViewTabs}
                    activeKey={developmentSubView}
                    onChange={onDevelopmentSubViewChange}
                    aria-label="Development view"
                />
            )}

            {activeMainTab === 'support' && canViewSupportTab && (
                <FloatingViewTabs
                    tabs={supportViewTabs}
                    activeKey={supportSubView}
                    onChange={onSupportSubViewChange}
                    aria-label="Support view"
                />
            )}
        </div>
    )
}

export default memo(ProjectMainContent)
